import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/breakout-rooms.vue
var o = {
	name: "DtIconBreakoutRooms",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--breakout-rooms"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Breakout Rooms",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M7 10h2V8H7v2Zm-5 0h2V8H2v2Zm5-5h3V2H7v3ZM2 5h2V3H2v2Zm3 5.089a.911.911 0 0 1-.911.911H1.91a.911.911 0 0 1-.91-.911V7.91c0-.503.408-.91.911-.911H4.09c.503 0 .91.408.911.911v2.178Zm5 0a.911.911 0 0 1-.911.911H6.91a.911.911 0 0 1-.91-.911V7.91c0-.503.408-.91.911-.911H9.09c.503 0 .91.408.911.911v2.178Zm-5-5A.911.911 0 0 1 4.089 6H1.91A.911.911 0 0 1 1 5.089V2.91c0-.503.408-.91.911-.911H4.09c.503 0 .91.408.911.911v2.18Zm6 0a.911.911 0 0 1-.911.911H6.91A.911.911 0 0 1 6 5.089V1.91c0-.503.408-.91.911-.911h3.178c.503 0 .91.408.911.911v3.18Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=breakout-rooms.js.map